import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-xl font-bold text-white text-center" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "flex flex-wrap justify-center gap-5 pt-5" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt"]

import facebook from "@/assets/images/social-media/facebook-icon.svg"
  import twitter from "@/assets/images/social-media/twitter-icon.svg"
  import instagram from "@/assets/images/social-media/instagram-icon.svg"
  import youtube from "@/assets/images/social-media/youtube-icon.svg"
  import linkedin from "@/assets/images/social-media/linkedin-icon.svg"
  import tiktok from "@/assets/images/social-media/tiktok-icon.svg"
  import workbean from "@/assets/images/social-media/workbean-icon.svg"
  import spotify from "@/assets/images/social-media/spotify-icon.svg"
  import website from "@/assets/images/social-media/others-icon.svg"

  interface Social {
    media_type: string
    link: string
  }

  interface Props {
    socials: Social[]
    company: string
    color: string
    url: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectContainer',
  props: {
    socials: null,
    company: null,
    color: null,
    url: null
  },
  setup(__props: any) {

const props = __props as {
    socials: Social[]
    company: string
    color: string
    url: string
  }

  const logos = {
    facebook: facebook,
    twitter: twitter,
    instagram: instagram,
    youtube: youtube,
    fb: facebook,
    tiktok: tiktok,
    linkedin: linkedin,
    workbean: workbean,
    spotify: spotify,
    others: website,
  }

  
  /**
   * get proper url
   * @param link - string of link url
   * @returns string of url with https://
   */
  const getLink = (link: string) => {
    if (link.includes("https")) return link
    return `https://${link}`
  }
  /**
   * @image - value of image
   * check if image is website and other then return website logo
   * else return assign image
   */
  const setImage = (image: string) => {
    if (image === "website" || image === "others") return website
    else return logos[image]
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col items-center rounded-3xl p-5 mt-3",
    style: _normalizeStyle({ background: __props.color || '#7442c8' })
  }, [
    _createElementVNode("h2", _hoisted_1, "Connect with " + _toDisplayString(props.company), 1),
    _createElementVNode("a", {
      href: props.url,
      class: "underline text-white text-center"
    }, _toDisplayString(props.url), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.socials, (social, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: `${index}_social`,
          href: getLink(social.link)
        }, [
          _createElementVNode("img", {
            class: "w-7 h-7",
            src: setImage(social.media_type),
            alt: social.media_type
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ], 4))
}
}

})